import { useLocalVideo } from '@providers/LocalVideoProvider';
import type { FC } from 'react';
import { Container, IconWrapper } from './style';
import CameraIcon from '/icon/camera.svg';

const CameraToggle: FC = () => {
  const { isVideoEnabled, toggleVideo } = useLocalVideo();

  return (
    <Container onClick={toggleVideo} isActive={isVideoEnabled}>
      <IconWrapper>
        <img src={CameraIcon} />
      </IconWrapper>
      <span>카메라</span>
    </Container>
  );
};

export default CameraToggle;
